import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="pt-32 pb-20 max-w-md mx-auto px-6" data-testid="login-page">
      <h1 className="font-display font-bold text-4xl md:text-5xl text-white tracking-tighter">Sign in</h1>
      <p className="text-zinc-400 mt-2">Welcome back to HashRate.</p>
      <form onSubmit={submit} className="mt-10 space-y-5">
        <div>
          <label className="font-mono text-xs uppercase tracking-widest text-zinc-500">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            className="w-full mt-2 bg-[#0a0a0b] border border-white/20 px-4 py-3 text-white focus:outline-none focus:border-yellow-400"
          />
        </div>
        <div>
          <label className="font-mono text-xs uppercase tracking-widest text-zinc-500">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            className="w-full mt-2 bg-[#0a0a0b] border border-white/20 px-4 py-3 text-white focus:outline-none focus:border-yellow-400"
          />
        </div>
        {error && <div className="text-sm text-red-400" data-testid="login-error">{error}</div>}
        <button
          type="submit"
          disabled={submitting}
          data-testid="login-submit-button"
          className="w-full bg-yellow-400 text-black font-bold uppercase tracking-wide py-3 hover:bg-yellow-500 transition disabled:opacity-50"
        >
          {submitting ? "Signing in..." : "Sign in"}
        </button>
      </form>
      <p className="mt-6 text-sm text-zinc-400">
        New to HashRate? <Link to="/register" className="text-yellow-400 hover:underline">Create an account</Link>
      </p>
    </div>
  );
}

export function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await register(email, password, name);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome to HashRate");
      navigate("/");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="pt-32 pb-20 max-w-md mx-auto px-6" data-testid="register-page">
      <h1 className="font-display font-bold text-4xl md:text-5xl text-white tracking-tighter">Create account</h1>
      <p className="text-zinc-400 mt-2">Join the high-signal community.</p>
      <form onSubmit={submit} className="mt-10 space-y-5">
        <div>
          <label className="font-mono text-xs uppercase tracking-widest text-zinc-500">Name</label>
          <input
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            data-testid="register-name-input"
            className="w-full mt-2 bg-[#0a0a0b] border border-white/20 px-4 py-3 text-white focus:outline-none focus:border-yellow-400"
          />
        </div>
        <div>
          <label className="font-mono text-xs uppercase tracking-widest text-zinc-500">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="register-email-input"
            className="w-full mt-2 bg-[#0a0a0b] border border-white/20 px-4 py-3 text-white focus:outline-none focus:border-yellow-400"
          />
        </div>
        <div>
          <label className="font-mono text-xs uppercase tracking-widest text-zinc-500">Password</label>
          <input
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="register-password-input"
            className="w-full mt-2 bg-[#0a0a0b] border border-white/20 px-4 py-3 text-white focus:outline-none focus:border-yellow-400"
          />
        </div>
        {error && <div className="text-sm text-red-400" data-testid="register-error">{error}</div>}
        <button
          type="submit"
          disabled={submitting}
          data-testid="register-submit-button"
          className="w-full bg-yellow-400 text-black font-bold uppercase tracking-wide py-3 hover:bg-yellow-500 transition disabled:opacity-50"
        >
          {submitting ? "Creating..." : "Create account"}
        </button>
      </form>
      <p className="mt-6 text-sm text-zinc-400">
        Already have an account? <Link to="/login" className="text-yellow-400 hover:underline">Sign in</Link>
      </p>
    </div>
  );
}
